import { render, staticRenderFns } from "./user_register.vue?vue&type=template&id=1868f841&scoped=true&"
import script from "./user_register.vue?vue&type=script&lang=js&"
export * from "./user_register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1868f841",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fuser%2Fuser_register.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports